export default (): string => {
    const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const seedLength = 5; // Length of the seed
    let seed = "";

    for (let i = 0; i < seedLength; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        seed += charset[randomIndex];
    }

    return seed;
}